module.exports = __webpack_public_path__ + "img/1160_MILR_Website_Heritage_01.7853f488.jpg";